import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=62fe0c27&scoped=true"
import script from "./AuthView.vue?vue&type=script&lang=js"
export * from "./AuthView.vue?vue&type=script&lang=js"
import style0 from "./AuthView.vue?vue&type=style&index=0&id=62fe0c27&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe0c27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62fe0c27')) {
      api.createRecord('62fe0c27', component.options)
    } else {
      api.reload('62fe0c27', component.options)
    }
    module.hot.accept("./AuthView.vue?vue&type=template&id=62fe0c27&scoped=true", function () {
      api.rerender('62fe0c27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AuthView.vue"
export default component.exports